export const environment = {
  production: false,
  env: 'dev2',
  apiBaseUrl: 'https://ai-plugins-api-dev2.azurewebsites.net'
};
